import { render, staticRenderFns } from "./TabsLayout.vue?vue&type=template&id=1508253e"
import script from "./TabsLayout.vue?vue&type=script&lang=js"
export * from "./TabsLayout.vue?vue&type=script&lang=js"
import style0 from "./TabsLayout.vue?vue&type=style&index=0&id=1508253e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports